import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import OutsideClickHandler from 'components/common/utilities/outside_click_handler';

export default function ModalCard({ aid, children, className, onClose }) {
  const classNames = classnames(className, 'modalCard-content');
  const content = (
    <div className={classNames} data-aid={aid}>
      {children}
    </div>
  );

  if (onClose) {
    return (
      <div className="modalCard-backdrop">
        <OutsideClickHandler onClickOutside={onClose}>{content}</OutsideClickHandler>
      </div>
    );
  }

  return <div className="modalCard-backdrop">{content}</div>;
}

ModalCard.propTypes = {
  aid: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  onClose: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/common/modal_card.jsx